import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/documentCard/styles.scss';export default {
  "documentCard": "_documentCard_1j2o1_1",
  "isSelected": "_isSelected_1j2o1_11",
  "actions": "_actions_1j2o1_14",
  "row": "_row_1j2o1_18",
  "documentIcon": "_documentIcon_1j2o1_23",
  "documentInfo": "_documentInfo_1j2o1_28",
  "top": "_top_1j2o1_42",
  "bottom": "_bottom_1j2o1_55",
  "hoverContainer": "_hoverContainer_1j2o1_64",
  "checkbox": "_checkbox_1j2o1_82",
  "actionIconBox": "_actionIconBox_1j2o1_100",
  "actionIcon": "_actionIcon_1j2o1_100",
  "lensButton": "_lensButton_1j2o1_111"
};